var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-card',{attrs:{"max-width":"400","width":"100%","flat":""}},[_c('v-card-text',[_c('Status'),_c('Program')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }